import { LoggingAPI } from "services/logging-server";
import { DeviceUtil } from "utils/device-util";

export function catchGlobalError() {
  // Capture synchronous errors
  window.onerror = async function (message, source, lineno, colno, error) {
    try {
      const params = new URLSearchParams(window.location.search);
      const authToken = params.get("code");
      await LoggingAPI.error({
        authToken,
        message: JSON.stringify({
          error: {
            message: error.message,
            originError: error,
            synchronousErrorMsg: message,
            source,
            lineno,
            colno,
          },
          deviceInfo: DeviceUtil.getDeviceInfo(),
        }),
      });
    } catch (_) {}
  };

  // Capture asynchronous errors
  window.addEventListener("unhandledrejection", async function (event) {
    try {
      const params = new URLSearchParams(window.location.search);
      const authToken = params.get("code");
      await LoggingAPI.error({
        authToken,
        message: JSON.stringify({
          error: {
            reason: event.reason,
          },
          deviceInfo: DeviceUtil.getDeviceInfo(),
        }),
      });
    } catch (_) {}
  });
}
